import { connect } from 'react-redux'
import { showModal } from 'redux/modules/modals'
import PlayersComponent from '../components/PlayersComponent'

const mapActionCreators = {
  showModal
}

const mapStateToProps = state => {
  return {
    players: state.players.list
  }
}

export default connect(mapStateToProps, mapActionCreators)(PlayersComponent)



// WEBPACK FOOTER //
// ./src/routes/Admin/Players/containers/AdminPlayersContainer.js